import { on } from '@ember/modifier';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonDemoButtonComponent from 'webapp/components/common/demo-button';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type Filter from 'webapp/models-custom/filter-sort/base';
import type SourceType from 'webapp/models-custom/source-type';

interface NoResultsItem {
	title: string;
	description: string;
	action: { text: string; fn: (...args: unknown[]) => void; icon?: string; theme?: string };
	icon?: string;
	sourceTypeObj?: SourceType;
	isHighlighted?: boolean;
	isHidden?: boolean;
	hasNewTag?: boolean;
}

interface Args {
	model: SourceType[];
	filterSort: Filter<SourceType>;
	onOpenSourceRequest: () => void;
	onConnectOrCreateToken?: (model: SourceType) => void;
	resetFilter: () => void;
	showDemoButton?: boolean;
}

export default class DataManagerNoResultsComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;

	items: NoResultsItem[] = [];
	companyName = '';

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.companyName = this.accountService.shownCompanyName;
	}

	get isDemoButtonShown() {
		return (
			this.args.showDemoButton &&
			this.accountService.isDemoButtonShown &&
			this.mmSourcesService.connectedSourcesCount < 4
		);
	}
	<template>
		<div id="data-manager-no-results">
			<div class="noResults">
				<CommonUiIconComponent @name="Search" @size="2xl" @class="noResults-icon" />
				No results found for
				<span>{{@filterSort.typedFilter}}</span>, but don't worry, there are other ways to
				sync your data with
				{{this.companyName}}.<br /><br />
				Check out the other ways to bring in data in the right panel. If you need any help,
				just reach out to our support team.
				{{#if @filterSort.isAnyNonSortFilterActive}}
					<a role="button" {{on "click" @resetFilter}}>Reset filter</a>
				{{/if}}
			</div>

			{{#if this.isDemoButtonShown}}
				<CommonDemoButtonComponent @trackingOrigin="datamanager" />
			{{/if}}
		</div>
	</template>
}
